export default {
  SET_TOKEN: 'SET_TOKEN',
  CLEAR_TOKEN: 'CLEAR_TOKEN',
};



// WEBPACK FOOTER //
// ./src/reducers/auth/types.js